export default __webpack_public_path__ + "static/media/Snd_TryW.08378c30.mp3";